import './playlistsFilter.scss';
import React, { Component } from 'react';
import RibbonsUtil from '../../utils/RibbonsUtil';
import store from '../../store';
import Translator from './../../requests/apa/Translator';
import { SHOW_MODAL, MODAL_MUSIC_FILTER } from '../../actions/modal';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';

class PlaylistsFilter extends Component {
    constructor(props) {
        super(props);
        this.modal = {
            type: SHOW_MODAL,
            modalType: MODAL_MUSIC_FILTER
        };
        this.state = {
            user: props.user,
            menuItems: [],
            genre: {
                genreAlias: '',
                genreName: ''
            },
            genreListIsOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user !== undefined && nextProps.user !== this.props.user) {
            this.getMenu(nextProps.user);
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if (user !== undefined) {
            this.getMenu(user);
        }
        window.SpatialNavigation.makeFocusable();
    }
    getMenu(user) {
        //get menu items
        let musicRb = new RibbonsUtil();
        musicRb
            .getMenuApi('genrePlaylist', user, {})
            .then(resp => {
                const { components } = resp.response;
                this.setState({ menuItems: components[0].items });
            })
            .catch(err => {
                logger.error('Fail to get Menu filter will not show: ' + err);
            });
    }

    toggleListGenreFilter() {
        const { genreListIsOpen, menuItems } = this.state;
        if (!genreListIsOpen) {
            this.modal.modalProps = {
                setGenreTitle: category => this.setGenreTitle(category),
                onSelectFilter: category => this.props.onSelectFilter(category),
                toggleListGenreFilter: () => this.toggleListGenreFilter(),
                menuItems
            };
            store.dispatch(this.modal);
        }
        this.setState(prevState => {
            return { genreListIsOpen: !prevState.genreListIsOpen };
        });
    }

    setGenreTitle(category) {
        this.setState({ genre: category });
    }

    handleMouseEnter = (e) => {
        Utils.handleMouseEnter(e)
    }

    render() {
        return (
            <div className="playlist-filter">
                <nav className="nav_interno_2 ni2_1e">
                    <ul>
                        <li
                            className="focusable focus-selector"
                            onClick={e => {
                                e.stopPropagation();
                                this.toggleListGenreFilter();
                            }}
                        >
                            <a
                                id={String(`keyCMR-${Math.floor(10000 + Math.random() * 90000)}`)}
                                onClick={e => {
                                    e.stopPropagation();
                                    this.toggleListGenreFilter();
                                }}
                                onMouseEnter={(e) => {this.handleMouseEnter(e)}}
                            >
                                <span>
                                    {this.state.genre.genreName === ''
                                        ? Translator.get('FILTER_BY', 'FILTRAR POR')
                                        : this.state.genre.genreName.toUpperCase()}
                                </span>
                                <i
                                    className={`${
                                        this.state.genreListIsOpen
                                            ? 'fa fa-angle-down rotate2 down'
                                            : 'fa fa-angle-down rotate2'
                                    }`}
                                />
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default PlaylistsFilter;



// WEBPACK FOOTER //
// ./src/components/PlaylistsFilter/index.jsx